export const isPlaylistItemType = type => {
  if (typeof type !== 'string') return false;
  return ['LESSON', 'TRACK', 'SHORT_FORM_CONTENT'].includes(type);
};
export const toPlaylistItemType = type => {
  switch (type) {
    case 'COURSE':
      return 'TRACK';
    case 'TRACK':
    case 'LESSON':
    case 'SHORT_FORM_CONTENT':
      return type;
    case 'PLAYLIST':
    case 'LEARNING_PATH':
      return null;
    default:
      return null;
  }
};